<span
  class="intent-panel__valid-range"
  [class.intent-panel__valid-range--success]="isValid === true"
  [class.intent-panel__valid-range--error]="isValid === false"
  [style.color]="color"
>
  <span class="intent-panel__valid-icon" aria-hidden="true">
    <span class="intent-panel__valid-icon-glyph" *ngIf="isValid === true; else invalidLengthIcon">&#10003;</span>
    <ng-template #invalidLengthIcon>
      <span class="intent-panel__valid-icon-glyph intent-panel__valid-icon-glyph--warning">&#9888;</span>
    </ng-template>
  </span>
  Valid: {{ validMin }}-{{ validMax }} km
</span>
